<template>
  <div class="back">
    <el-button @click="jump">返回</el-button>
  </div>
</template>

<script>
export default {
  name: 'back',
  methods: {
    jump () {
      window.history.go(-1)
    }
  }
}

</script>